import React, {useEffect, useContext, useState} from 'react'
import {
  Checkbox,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import {ReservationConfigurationContext} from '../../../context/ReservationConfiguration'
import {useParams} from 'react-router'
import AdditionalDateInput from './AdditionalDateInput'

const FTextField = ({data, onChange = (e, key, value) => {}}) => {
  const {additionalFieldValues, getAdditionalFieldValues} = useContext(
    ReservationConfigurationContext
  )
  const {group_id} = useParams()
  const [dateOptions, setDateOptions] = useState([])
  const [limitedDateOptions, setLimitedDateOptions] = useState([])
  let dateLimitOptions = [
    {name: 'Disabled', value: 'disabled'},
    {name: 'Between', value: 'between'},
  ]

  let dateCalculationOptions = [
    {name: 'Add', value: 'add'},
    {name: 'Subtract', value: 'sub'},
  ]

  useEffect(() => {
    getAdditionalFieldValues(group_id, ['DateField', 'DateTimeField'], true, false, false)
  }, [group_id, getAdditionalFieldValues])

  useEffect(() => {
    if (additionalFieldValues.data.data?.fields) {
      let fields = additionalFieldValues.data?.data?.fields.map(f => {
        return {
          name: f.name,
          value: f.id,
        }
      })
      setDateOptions([
        {name: 'None', value: 'none'},
        {name: 'Current Date', value: 'date_today'},
        ...fields,
      ])
      setLimitedDateOptions([
        {name: 'None', value: 'none'},
        {name: 'Current Date', value: 'date_today'},
        ...fields,
      ])
    }
  }, [additionalFieldValues])

  return (
    <>
      <FormControl variant="outlined" className="ap-textfield" style={{width: 200, marginTop: 16}}>
        <InputLabel id="">Default Value</InputLabel>
        <Select
          labelId=""
          id=""
          value={data.default_value.value}
          label="Default Value"
          onChange={(e, value) => onChange(e, 'default_value', value, 'value')}
          style={{width: '200px'}}
        >
          {dateOptions.map(opt => {
            return <MenuItem value={opt.value}>{`${opt.name}`}</MenuItem>
          })}
        </Select>
      </FormControl>
      {data.default_value && (
        <AdditionalDateInput
          fieldFor="default_value"
          data={data.default_value}
          onChange={onChange}
        />
      )}
      <br />
      <FormControl variant="outlined" className="ap-textfield" style={{width: 200, marginTop: 16}}>
        <InputLabel id="">Limit Date Selection</InputLabel>
        <Select
          labelId=""
          id=""
          value={data.selection_limits}
          label="Limit Date Selection"
          onChange={(e, value) => onChange(e, 'selection_limits')}
          style={{width: '200px'}}
        >
          {dateLimitOptions.map(opt => {
            return <MenuItem value={opt.value}>{`${opt.name}`}</MenuItem>
          })}
        </Select>
      </FormControl>
      <br />
      {data.selection_limits === 'between' && (
        <>
          <FormControl
            variant="outlined"
            className="ap-textfield"
            style={{width: 200, marginTop: 16}}
          >
            <InputLabel id="">Start</InputLabel>
            <Select
              labelId=""
              id=""
              label="Start"
              value={data.selection_limits_minimum.value}
              onChange={(e, value) => onChange(e, 'selection_limits_minimum', value, 'value')}
              style={{width: '200px'}}
            >
              {limitedDateOptions.map(opt => {
                return <MenuItem value={opt.value}>{`${opt.name}`}</MenuItem>
              })}
            </Select>
          </FormControl>
          {data.selection_limits_minimum && (
            <AdditionalDateInput
              fieldFor="selection_limits_minimum"
              data={data.selection_limits_minimum}
              onChange={onChange}
            />
          )}
        </>
      )}

      <br />
      {data.selection_limits === 'between' && (
        <>
          <FormControl
            variant="outlined"
            className="ap-textfield"
            style={{width: 200, marginTop: 16}}
          >
            <InputLabel id="">End</InputLabel>
            <Select
              labelId=""
              id=""
              label="End"
              value={data.selection_limits_maximum.value}
              onChange={(e, value) => onChange(e, 'selection_limits_maximum', value, 'value')}
              style={{width: '200px'}}
            >
              {limitedDateOptions.map(opt => {
                return <MenuItem value={opt.value}>{`${opt.name}`}</MenuItem>
              })}
            </Select>
          </FormControl>
          {data.selection_limits_maximum && (
            <AdditionalDateInput
              fieldFor="selection_limits_maximum"
              data={data.selection_limits_maximum}
              onChange={onChange}
            />
          )}
        </>
      )}
    </>
  )
}

export default FTextField
